import { CircularProgressTheme as CircularProgressDefaultTheme } from "@acin.reactjs/acin-ui/progress";
import { DefaultTheme } from "styled-components";

const CircularProgressTheme = (
  theme: DefaultTheme,
): CircularProgressDefaultTheme => ({
  progressBar: { stroke: theme.palette.secondary[500] },
});

export default CircularProgressTheme;
